import Lenis from "../../build/node_modules/@studio-freight/lenis";
//
import Util from "./Util.js";
import { gsap } from "./Util.js";
import { ScrollTrigger } from "../_libs/ScrollTrigger";

class Scroll extends Util {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.start();
    this.events();
    this.parallax();
    this.startRaf();
    this.anchor();
  }

  start() {
    this.lenis = new Lenis({
      duration: 0.4,
      direction: "vertical",
      gestureDirection: "vertical",
      smooth: true,
      mouseMultiplier: 0.5,
      smoothTouch: false,
      touchMultiplier: 1,
      infinite: false,

      easing: function (t) {
        // return Math.min(1, 1.005 - Math.pow(2, -10 * t));
        return Math.min(1, 1.01 - Math.pow(100, -1 * t));
      },
    });

    gsap.delayedCall(0.4, () => {
      if (document.URL.includes("#")) {
        const hash = document.URL.split("#")[1];
        if (hash) {
          const targetElement = document.getElementById(hash);
          if (targetElement) {
            this.lenis.scrollTo(targetElement.offsetTop - 200);
          }
        }
      }
    });
  }

  events() {
    this.footer = document.querySelector(".footer");

    this.lenis.on("scroll", (e) => {
      this.website.currentY = e.scroll;
      this.website.velocity = e.velocity;

      const footerHeight = this.footer.getBoundingClientRect().top;

      if (150 > footerHeight) {
        document.documentElement.classList.add("nav-hide");
      } else {
        document.documentElement.classList.remove("nav-hide");
      }
    });
  }

  parallax() {
    if (!this.website.isDesktop) return;

    const parallax = document.querySelectorAll(".parallax");

    for (let i = 0; i < parallax.length; i++) {
      gsap.to(parallax[i], {
        y: -(parallax[i].offsetHeight / 10),
        scrollTrigger: {
          trigger: parallax[i],
          start: "top bottom",
          end: "bottom top",
          // markers: true,
          scrub: true,
        },
      });
    }
  }

  startRaf() {
    const raf = (time) => {
      this.lenis.raf(time);
      requestAnimationFrame(raf);
    };
    requestAnimationFrame(raf);
  }

  anchor() {
    const anchor = document.querySelector(".to-top");
    anchor.addEventListener("click", () => {
      this.lenis.scrollTo(0);
    });
  }
}

gsap.registerPlugin(ScrollTrigger);
export default Scroll;
